import ContentsToReact from '@/components/ContentsToReact/ContentsToReact';
import GenericModals from '@/components/GenericModals/GenericModals';
import Page from '@/components/Page/Page';
import PageHead from '@/components/PageHead/PageHead';
import { extractContents } from '@/helpers/extractContents';
import extractPageMetaFromRouteData from '@/helpers/extractPageMetaFromRouteData';
import { useInitialPageDataLayer } from '@/hooks/useInitialPageDataLayer/useInitialPageDataLayer';
import type { PageModel } from '@/models/page';
import EnercityFooter from '@uikit/components/EnercityFooter/EnercityFooter';
import PressPageTitle from '@uikit/components/Press/PressPageTitle/PressPageTitle';
import PressFilter from '@uikit/components/PressFilter/PressFilter';
import PressLayout from '@uikit/components/PressLayout/PressLayout';
import Section from '@uikit/components/Section/Section';
import { SectionVariant } from '@uikit/components/Section/consts';
import cmsComponents from './PressOverviewPage.cmsComponents';
import type { PressOverviewPageProps } from './interface';

const PressOverviewPage = (routeData: PageModel<PressOverviewPageProps>) => {
  const meta = extractPageMetaFromRouteData(routeData);

  const {
    contents,
    modals,
    props: {
      initialPressArticles = [],
      mediaTypes = [],
      title,
      subTitle,
      pressType,
      tags,
    },
  } = routeData;

  const {
    extractedContents: [header, additionalContents],
  } = extractContents(['header', 'additional-contents', 'footer'], contents);

  useInitialPageDataLayer({ resourceType: 'frontpage' });

  return (
    <>
      <PageHead {...meta} />
      <PressLayout>
        <Page>
          {header && (
            <ContentsToReact contents={header} cmsComponents={cmsComponents} />
          )}

          <PressPageTitle title={title} subText={subTitle} />
          <Section variant={SectionVariant.Default}>
            <PressFilter
              initialPressArticles={initialPressArticles}
              pressType={pressType}
              tags={tags}
              mediaTypes={mediaTypes}
            />
          </Section>

          {additionalContents && (
            <ContentsToReact
              contents={additionalContents}
              cmsComponents={cmsComponents}
            />
          )}
        </Page>
        <EnercityFooter />
      </PressLayout>
      <GenericModals modals={modals} cmsComponents={cmsComponents} />
    </>
  );
};

export default PressOverviewPage;
